import type { MouseEvent } from 'react'

/**
 * Click handler for rows and buttons rendered as real links.
 *
 * A plain left-click runs the row's own handler (analytics, router state, special-case routing) and
 * keeps the SPA navigation. A modified click (Ctrl/Cmd/Shift/Alt) or a non-primary button is left to
 * the browser, so "open in new tab" works from the keyboard and the mouse wheel.
 */
export const handleLinkClick = (e: MouseEvent, onClick?: () => void) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    // No handler: leave the click to the link, so the router navigates itself.
    if (!onClick) return
    e.preventDefault()
    onClick()
}
